import React from 'react';

const ComingSoonText = ({children, additionalclasses, onCLick}) => {
    return (
        <span onClick={onCLick} className={`items-center gap-[4px] rounded-[4px] custom-text-grey-900 poppins-regular text-[12px] w-fit px-[6px] truncate min-h-[18px] grid items-center justify-center ${additionalclasses} ${additionalclasses ? '' : 'custom-bg-grey-50'}`}>{children}</span>
    );
};

export default ComingSoonText;